import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: true }, // 表示此路由需要认证
    component: () => import('../views/home/home.vue')
  },
  // 房间地图
  {
    path: '/RoomHandbook',
    name: 'RoomHandbook',
    meta: { requiresAuth: true }, // 表示此路由需要认证
    component: () => import('../views/RoomHandbook/IndexView.vue'),
  },
  // 签名
  {
    path: '/RoomHandbook/signature',
    name: 'signature', 
    meta: { requiresAuth: true },
    component: () => import('../views/RoomHandbook/signature.vue')
  },
  // 房间地图详情
  {
    path: '/RoomHandbook/details',
    name: 'details', 
    meta: { requiresAuth: true },
    component: () => import('../views/RoomHandbook/details.vue')
  },
  // 房间地图打印
  {
    path: '/RoomHandbook/roomMapPrint',
    name: 'roomMapPrint', 
    meta: { requiresAuth: true },
    component: () => import('../views/RoomHandbook/roomMapPrint.vue')
  },
  // dailyReport页面
  {
    path: '/DailyReport',
    name: 'DailyReport', 
    meta: { requiresAuth: true },
    component: () => import('../views/DailyReport/dailyReport.vue'),
    children: [
      {
        path: '',
        name: 'HousekeepingDailyReport',
        component: () => import('../views/DailyReport/housekeepingDailyReport.vue')
      },
      {
        path: 'issue',
        name: 'IssueAlert',
        component: () => import('../views/DailyReport/issueAlert.vue')
      },
      {
        path: 'chart',
        name: 'LineChart',
        component: () => import('@/views/DailyReport/lineChart.vue')
      }
    ]
  },
  // CheckOutEye页面
  {
    path: '/checkOutEye',
    name: 'CheckOutEye', 
    meta: { requiresAuth: true },
    component: () => import('../views/CheckOutEye/checkouteye.vue')
  },
  // 需要清洁的dorm
  {
    path: '/dormclean',
    name: 'DormClean', 
    meta: { requiresAuth: true },
    component: () => import('../views/DormClean/dormClean.vue')
  },
  // 静态CleaningLogs页面(V3是最新版本预测明天任务，V2是只能分配当天任务)
  {
    path: '/cleaningLogs',
    name: 'CleaningLogs', 
    meta: { requiresAuth: true },
    component: () => import('../views/CleaningLogs/cleaninglogsV3.vue')
  },
  // 预分配任务页面
  {
    path: '/LastNightPlan',
    name: 'LastNightPlan', 
    meta: { requiresAuth: true },
    component: () => import('../views/CleaningLogs/LastNightPlan.vue')
  },
  // 动态CleaningLogs页面
  {
    path: '/dynamiccleaninglogs',
    name: 'Dynamiccleaninglogs', 
    meta: { requiresAuth: true },
    component: () => import('../views/CleaningLogs/dynamiccleaninglogs.vue')
  },
  // 前台更新状态页面
  {
    path: '/updateStatus',
    name: 'UpdateStatus', 
    meta: { requiresAuth: true },
    component: () => import('../views/frontDesk/updateStatus.vue')
  },
  // 检查Dorm
  {
    path: '/checkDorm',
    name: 'CheckDorm', 
    meta: { requiresAuth: true },
    component: () => import('../views/checkDorm/checkDorm.vue')
  },
  // 分配页面
  {
    path: '/assignTasks',
    name: 'AssignTasks', 
    meta: { requiresAuth: true },
    component: () => import('../views/Manager/assignTasks.vue')
  },
  // 分配页面
  {
    path: '/allocate',
    name: 'Allocate', 
    meta: { requiresAuth: true },
    component: () => import('../views/Manager/allocate.vue')
  },
  // 人员管理页面
  {
    path: '/personnelManagement',
    name: 'PersonnelManagement', 
    meta: { requiresAuth: true },
    component: () => import('../views/Manager/personnelManagement.vue')
  },
  // 清洁页面
  {
    path: '/clean',
    name: 'Clean', 
    meta: { requiresAuth: true },
    component: () => import('../views/Clean/clean.vue')
  },
  // 检查页面
  {
    path: '/check',
    name: 'Check', 
    meta: { requiresAuth: true },
    component: () => import('../views/Clean/check.vue')
  },
  // 检查页面打印
  {
    path: '/check_print',
    name: 'Check Print', 
    meta: { requiresAuth: true },
    component: () => import('../views/Clean/check_print.vue')
  },
  // 清洁页面V2
  {
    path: '/cleanV2',
    name: 'CleanV2', 
    meta: { requiresAuth: true },
    component: () => import('../views/Clean/cleanV2.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView'),
    meta: { title: '登录' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('user') // 判断用户是否已登录
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 如果目标路由需要登录
    if (!isAuthenticated) {
      next({ name: 'login' }) // 如果用户未登录，重定向到首页
    } else {
      next() // 用户已登录，允许导航
    }
  } else {
    next() // 如果不需要认证，允许导航
  }
})

export default router
